 <!-- start Work Process -->
 <section class="section bg-light" id="creators">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="text-center mb-5">
                    <h2 class="mb-3 fw-semibold lh-base">Top Creator This Week</h2>
                    <p class="text-muted">NFTs are valuable because they verify the authenticity of a non-fungible asset. This makes these assets unique and one of a kind.</p>
                </div>
            </div>
        </div><!-- end row -->
        <div class="row">
            <div class="col-xl-4 col-md-6" *ngFor="let data of creatorData">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex">
                            <div class="flex-shink-0">
                                <img src="{{data.img}}" alt="" class="avatar-sm object-cover rounded" />
                            </div>
                            <div class="ms-3 flex-grow-1">
                                <a routerLink="/pages/profile">
                                    <h5 class="mb-1">{{data.title}}</h5>
                                </a>
                                <p class="text-muted mb-0"><i class="mdi mdi-ethereum text-primary fs-14"></i> {{data.price}}</p>
                            </div>
                            <div>
                                <div class="dropdown float-end" ngbDropdown>
                                    <button class="btn btn-ghost-primary btn-icon dropdown arrow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                                        <i class="ri-more-fill align-middle fs-16"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end" ngbDropdownMenu >
                                        <li><a class="dropdown-item view-item-btn" href="javascript:void(0);">Share</a></li>
                                        <li><a class="dropdown-item edit-item-btn" href="javascript:void(0);" data-bs-toggle="modal">Report</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!--end col-->
        </div>
    </div><!-- end container -->
</section><!-- end Work Process -->